import { App } from '@capacitor/app';
import { SOURCE_ENTITY_PATH_BUILDERS } from 'app/pages/pushNotifications/PushNotificationPanel/components/PushNotificationCard/PushNotificationCard.constants';
import _ from 'lodash';

import { logger } from 'utils/logger';
import { getNativePlatform } from 'utils/platform';

import { NATIVE_PLATFORM, NATIVE_PUSH_DATA_KEYS, PUSH_PLATFORM } from './nativePush.constants';

export const getPushPlatform = () =>
  getNativePlatform() === NATIVE_PLATFORM.IOS ? PUSH_PLATFORM.APNS : PUSH_PLATFORM.FCM;

export const getDeviceMetadata = async () => {
  const appInfo = await App.getInfo().catch(error => {
    logger.error('[NativePush] failed to read app info', error);

    return null;
  });

  return {
    platform: getNativePlatform(),
    pushPlatform: getPushPlatform(),
    bundleId: appInfo?.id ?? null,
    appNativeVersion: appInfo?.version ?? null,
    appNativeBuild: appInfo?.build ?? null,
    bundleVersion: appInfo?.version ?? null,
    locale: globalThis.navigator?.language ?? null,
  };
};

export const getDeepLinkPath = data => {
  const sourceType = data?.[NATIVE_PUSH_DATA_KEYS.SOURCE_TYPE];
  const sourceEntityId = data?.[NATIVE_PUSH_DATA_KEYS.SOURCE_ENTITY_ID];

  const buildPath = SOURCE_ENTITY_PATH_BUILDERS[sourceType];

  if (!buildPath || _.isNil(sourceEntityId)) {
    return null;
  }

  return buildPath(sourceEntityId);
};
